module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"views":"Consultations","writes":"Contributions","subjects":"Subjects"},"fr":{"views":"Consultations","writes":"Contributions","subjects":"Sujets"}}')
  delete Component.options._Ctor
}
